import React from "react";
import { TABLE_PAD_LIST } from "../constant";
import { TablePadCard } from "./TablePadCard";
import styles from "./ORStretcherPads.module.scss";
import { FormActions } from "../FormActions";
import { CustomOrderForm } from "./CustomOrderForm";

export const TablePadSelection = ({ selected, onSelect, onNext, onDownload }) => (
  <div className={styles.section}>
    <CustomOrderForm onDownload={onDownload} padType="O.R. table" />
    <div className={styles.padGrid} role="radiogroup" aria-label="Table pad model">
      {TABLE_PAD_LIST.map((pad) => (
        <TablePadCard
          key={pad.modelName}
          modelName={pad.modelName}
          image={pad.image}
          selected={selected?.modelName === pad.modelName}
          onSelect={() => onSelect(pad)}
        />
      ))}
    </div>

    <FormActions onClick={onNext} disabled={!selected} label="Next" />
  </div>
);
